import React from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store";
import { setLoadingState } from "redux/actions";

import { EditorState } from "draft-js";
import { Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import CustomizedEditor from "./Editor";

import { removeFile } from "./CustomizedComponentsUtils";

import { getFileIcon } from "utils";

import { FileType } from "types";
import { remove } from "helpers";

interface IEditorComponent {
  onDrop?: (event: React.DragEvent<HTMLDivElement>) => void;
  submit: () => Promise<void>;
  editorState: EditorState;
  selectedFiles?: any[];
  setSelectedFiles?: React.Dispatch<React.SetStateAction<FileType[]>>;
  onEditorStateChange: (editorState: EditorState) => void;
  updating?: boolean;
  sendButton?: boolean;
  options?: string[];
  resetUpdate?: () => void;
  discardable?: boolean;
  discardConfirmMessage?: string;
  placeholder?: string;
  localImageUpload?: boolean;
  onLocalFileSelected?: (blobUrl: string, file: File) => void;
  submitting?: boolean;
}

const EditorComponent: React.FC<IEditorComponent> = ({
  onDrop,
  submit,
  editorState,
  selectedFiles,
  setSelectedFiles,
  onEditorStateChange,
  updating,
  options = ["inline", "fontSize", "list", "textAlign", "link", "image"],
  sendButton = true,
  resetUpdate,
  discardable,
  discardConfirmMessage,
  placeholder,
  localImageUpload,
  onLocalFileSelected,
  submitting,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleFileRemoveDelete = async (fileIndex: number, fileId?: number) => {
    if (selectedFiles !== undefined && setSelectedFiles)
    removeFile(fileIndex, selectedFiles, setSelectedFiles);

    if (fileId) {
      dispatch(setLoadingState(true));
      try {
        await remove(`/arquivo/${fileId}`);
      } catch (error) {
        console.log({ error });
      }
      dispatch(setLoadingState(false));
    }
  };
  return (
    <>
      <div onDrop={onDrop}>
        <CustomizedEditor
          onEditorStateChange={onEditorStateChange}
          submit={submit}
          editorState={editorState}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          updating={updating}
          options={options}
          sendButton={sendButton}
          resetUpdate={resetUpdate}
          discardable={discardable}
          discardConfirmMessage={discardConfirmMessage}
          placeholder={placeholder}
          localImageUpload={localImageUpload}
          onLocalFileSelected={onLocalFileSelected}
          submitting={submitting}
        />
      </div>

      <div className="d-flex overflow-auto">
        {selectedFiles?.length
          ? (selectedFiles || []).map((f, i) => {
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border"
                  key={i + "-file"}
                  style={{
                    marginRight: "10px",
                    minWidth: "250px",
                    maxWidth: "250px",
                  }}
                >
                  <div className="p-2">
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        <div className="avatar-sm">
                          <i
                            className={`mdi ${getFileIcon(
                              f.id ? f.nome : f.name
                            )} avatar-title bg-primary rounded`}
                            style={{ fontSize: "1.5rem" }}
                          />
                        </div>
                      </Col>
                      <Col
                        className="ps-0 overflow-hidden"
                        style={{ textOverflow: "ellipsis" }}
                      >
                        <Link to="#" className="text-muted fw-bold text-nowrap">
                          {f.id ? f.nome : f.name}
                        </Link>
                      </Col>
                      <Col className="text-end">
                        <Link
                          to="#"
                          className="btn btn-link btn-lg text-muted shadow-none"
                        >
                          <i
                            className="dripicons-cross"
                            onClick={() => handleFileRemoveDelete(i, f.id)}
                          ></i>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </Card>
              );
            })
          : null}
      </div>
    </>
  );
};

export default EditorComponent;
